function modalVideoLaunch() {
	$(".js-video-button").modalVideo({
		youtube: {
			controls: 0
		}
	});
}